// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { Resources } from "../../Commons/properties/Resources.js";
import { RulesSet } from "../Rules/RulesSet.js";
import { AlertType } from "./AlertType.js";
import { AlertCondition } from "./AlertCondition.js";
import { AlertAfterExecute } from "./AlertAfterExecute.js";
import { AlertAction } from "./AlertConstants.js";
import { AlertNotification } from "./AlertNotification.js";
import { AlertImportance } from "./AlertImportance.js";
import { HistoryType } from "../History/HistoryType.ts";

export class AlertUtils
{
    static DataCache = null;

    static AllowPlaceOrder ()
    {
        let hideOE = Resources.isHidden("screen.Alerts.Action.PlaceOrder");
        return !hideOE && this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PLACE_ORDER);
    }

    static GetAlertTypeItems (isDEFAULT)
    {
        let item = [];

        //CERFFFFFFFFFFFFFFF
        // if (isDEFAULT)
        //     item.push({ value: AlertType.DEFAULT, text: Resources.getResource('chart.view.source0') })

        item.push(
            { value: AlertType.ASK, text: Resources.getResource('screen.Alerts.Ask') },
            { value: AlertType.BID, text: Resources.getResource('screen.Alerts.Bid') },
            { value: AlertType.LAST, text: Resources.getResource('screen.Alerts.Last') },
            { value: AlertType.CHANGE, text: Resources.getResource('screen.Alerts.ChangePr') },
            { value: AlertType.VOLUME, text: Resources.getResource('screen.Alerts.Volume') }
        );

        return item;
    }

    static GetAlertConditionItems ()
    {
        let item = [
            { value: AlertCondition.MORE, text: Resources.getResource('screen.Alerts.Condition.Greater') },
            { value: AlertCondition.LESS, text: Resources.getResource('screen.Alerts.Condition.Less') },
            { value: AlertCondition.MORE_EQUAL, text: Resources.getResource('screen.Alerts.Condition.Greater or equal') },
            { value: AlertCondition.LESS_EQUAL, text: Resources.getResource('screen.Alerts.Condition.Less or equal') }
        ];
        return item;
    }

    static GetAlertAfterExecuteItems ()
    {
        let item = [
            { value: AlertAfterExecute.STOP, text: Resources.getResource('screen.Alerts.AfterExecute.Stop') },
            { value: AlertAfterExecute.REMOVE, text: Resources.getResource('screen.Alerts.AfterExecute.Remove') }
        ];
        return item;
    }

    static GetAlertActionItems ()
    {
        let item = [];
        let hideOE = Resources.isHidden("screen.Alerts.Action.PlaceOrder");
        if (this.AllowPlaceOrder())
            item.push({ value: AlertAction.PLACE_ORDER_NOTIFY, text: Resources.getResource('screen.Alerts.Action.PlaceOrder') });

        item.push({ value: AlertAction.NOTIFY, text: Resources.getResource('screen.Alerts.Action.Notify') });

        return item;
    }

    static GetAlertNotificationItems (value)
    {
        let item = [];
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_EMAIL))
            item.push({ value: AlertNotification.EMAIL, text: Resources.getResource('screen.Alerts.Notify.Email'), checked: value & AlertNotification.EMAIL });
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PUSH))
            item.push({ value: AlertNotification.PUSH, text: Resources.getResource('screen.Alerts.Notify.Push'), checked: value & AlertNotification.PUSH });
        item.push({ value: AlertNotification.SHOW_POP_UP, text: Resources.getResource('screen.Alerts.Notify.Popup'), checked: value & AlertNotification.SHOW_POP_UP });
        item.push({ value: AlertNotification.SOUND, text: Resources.getResource('screen.Alerts.Notify.Sound'), checked: value & AlertNotification.SOUND });
        return item;
    }

    static VerifyNotificationValue (value)
    {
        let verified = 0;
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_EMAIL) && (value & AlertNotification.EMAIL))
            verified += AlertNotification.EMAIL;
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PUSH) && (value & AlertNotification.PUSH))
            verified += AlertNotification.PUSH;
        if (value & AlertNotification.SHOW_POP_UP)
            verified += AlertNotification.SHOW_POP_UP;
        if (value & AlertNotification.SOUND)
            verified += AlertNotification.SOUND;
        return verified;
    }

    static GetAlertImportanceItems ()
    {
        let item = [
            { value: AlertImportance.HIGH, text: Resources.getResource('screen.Alerts.Importance.High') },
            { value: AlertImportance.MEDIUM, text: Resources.getResource('screen.Alerts.Importance.Medium') },
            { value: AlertImportance.LOW, text: Resources.getResource('screen.Alerts.Importance.Low') }
        ];
        return item;
    }

    static GetDefaultAlertTypeByInstrument (instrument)
    {
        switch (instrument.HistoryType)
        {
            case HistoryType.BID:
                return AlertType.BID;
            case HistoryType.QUOTE_TRADES:
                return AlertType.LAST;
            case HistoryType.ASK:
                return AlertType.ASK;
        }
    }

    static GetCorrectPriceForAlertByInstrument (instrument, historyType)
    {
        if (!instrument)
            return NaN;

        let Level1 = instrument.Level1;
        if (!Level1)
            return NaN;

        switch (historyType)
        {
            case HistoryType.BID:
                return Level1.GetBid();
            case HistoryType.ASK:
                return Level1.GetAsk();
            case HistoryType.LAST:
                return Level1.GetLastPrice();
            default:
                return Level1.GetBid();
        }
    }

    static GetValuesAndStates (value)
    {
        let res = {}
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_EMAIL))
            res[AlertNotification.EMAIL] = value & AlertNotification.EMAIL;
        if (this.DataCache.isAllowedForMyUser(RulesSet.FUNCTION_ALERTS_PUSH))
            res[AlertNotification.PUSH] = value & AlertNotification.PUSH;
        res[AlertNotification.SHOW_POP_UP] = value & AlertNotification.SHOW_POP_UP
        res[AlertNotification.SOUND] = value & AlertNotification.SOUND;
        return res;
    }
}